import Header from '../_layouts/public/Header';
import Footer from '../_layouts/public/Footer';
import WelcomeArea2 from '../_layouts/public/pages/WelcomeArea2';
import { Link } from 'react-router-dom';

const About = (props) => {
    const pg = 'About Us';

  return (
    <>
    <Header />
    <WelcomeArea2 pg={pg} />

    <section className="mosh-aboutUs-area pt-5">
        <div className="container pt-4">
            <div className="row align-items-center">
                <div className="col-12 col-md-6">
                    <div className="mosh-about-us-content">
                        <div className="section-heading mb-4">
                            <h2><span className="green-span">About our</span><br />Mission and Vision</h2>
                        </div>
                        <p>Our mission is to ... <i>details of mission statement will be provided here 
                            details of mission statement will be provided here
                            details of mission statement will be provided here</i></p> 
                        
                        <p>Our vision is to ... <i>details of vision statement will be provided here 
                            details of mission statement will be provided here
                            details of mission statement will be provided here </i></p>
                        
                        <div className="section-heading mb-4 mt-5">
                            <h2><span className="green-span">Objectives and </span><br />Core Values</h2>
                        </div>
                        <p>The main objectives and core values of the company are 
                            <i>details of objectives and core values of the company will be provided here 
                            details of objectives and core values of the company will be provided here
                            details of objectives and core values of the company will be provided here</i></p>
                        
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="mosh-about-us-thumb wow fadeInUp" data-wow-delay="0.5s">
                        <img src="img/bg-img/headpiece.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section className="few-words-from-ceo mt-5 d-md-flex">
        <div className="row">
            <div className="col-12 col-md-6 few-words-thumb bg-img wow fadeInRightBig" data-wow-delay="1.1s" style={{backgroundImage: 'url(img/bg-img/cta-2.jpg)' }}></div>

            <div className="col-12 col-md-6 pt-5 mosh-features-area few-words-contents d-flex justify-content-center wow fadeInLeftBig" data-wow-delay="0.1s">
                <div className="container-fluid pt-5">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10">
                            <div className="few-words-text">
                                <div className="section-heading">
                                    <p>welcome to mipat group</p>
                                    <h2><span className="green-span">From the Managing </span>
                                    Director's Office</h2>
                                </div>
                                <p style={{ color: '#ccc' }}>Our company, {props.company} is .. <i>the Director's statement abou tthe 
                                    company here the Director's statement abou tthe 
                                    company here the Director's statement abou tthe 
                                    company here the Director's statement abou tthe 
                                </i></p>

                                <p className="mt-4" style={{ color: '#ccc' }}>MIPAT Group is .. <i>the Director's statement abou tthe 
                                    company here the Director's statement abou tthe 
                                    company here
                                </i></p>

                                <div className="ceo-meta-data d-flex align-items-center mt-50">
                                    {/* <div className="ceo-thumb bg-img" style={{backgroundImage: 'url(img/bg-img/ceo.jpg)' }}></div> */}
                                    <div className="ceo-name">
                                        <h6>Isaiah Adekanye</h6>
                                        <p style={{ color: '#ccc' }} >Managing Director</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="mosh-about-features-area section_padding_100">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-12 col-md-4">
                    <div className="mosh-features-thumb wow fadeIn" data-wow-delay="0.5s">
                        <img src="img/bg-img/features-2.png" alt="" />
                    </div>
                </div>

                <div className="col-12 col-md-8">
                    <div className="mosh-about-us-content">
                        <div className="section-heading">
                            <h2><span className="green-span">More facts about MIPAT </span>
                            <br />and why clients choose us</h2>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <div className="single-feature-area d-flex">
                                    <div className="feature-icon mr-30">
                                        <img src="img/core-img/settings-2.png" alt="" />
                                    </div>
                                    <div className="feature-content">
                                        <h5>A big team</h5>
                                        <p>Etiam nec odio vestibulum est mat tis effic iturut magna.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-12 col-sm-6">
                                <div className="single-feature-area d-flex">
                                    <div className="feature-icon mr-30">
                                        <img src="img/core-img/photo-camera.png" alt="" />
                                    </div>
                                    <div className="feature-content">
                                        <h5>Photo enthuziast</h5>
                                        <p>Etiam nec odio vestibulum est mat tis effic iturut magna.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-12 col-sm-6">
                                <div className="single-feature-area d-flex">
                                    <div className="feature-icon mr-30">
                                        <img src="img/core-img/like.png" alt="" />
                                    </div>
                                    <div className="feature-content">
                                        <h5>30k Followers</h5>
                                        <p>Etiam nec odio vestibulum est mat tis effic iturut magna.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6">
                                <div className="single-feature-area d-flex">
                                    <div className="feature-icon mr-30">
                                        <img src="img/core-img/gamepad.png" alt="" />
                                    </div>
                                    <div className="feature-content">
                                        <h5>We love gaming</h5>
                                        <p>Etiam nec odio vestibulum est mat tis effic iturut magna.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href="#" className="btn mosh-btn mt-50">Read More</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="py-5" style={{ background: '#D4F085' }}>
        <div className="container py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10">
                    <div className="text-center">
                        <h5 className="mt-30 text-dark">
                            {props.company} is an indigenous 
                            Nigerian registered company specialized in the processing of natural and 
                            organic resources. Our products include SpillClean&trade;, Fertilizer and Water Mixing Machine, 
                            Cocopeat and Coconut Husk Chips, etc.</h5>

                        <Link to="/products" class="btn mosh-btn mt-4">shop our products</Link>                                     
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <Footer />
    </>
  )
}
export default About;